import { useBoolean } from "../hooks/useBoolean";
import { useRecoilState, useRecoilValue } from "recoil";
import { audioContextState, coPilotDisplaySettingsSelector } from "../store/CopilotDisplaySettingsState";
import { Button, Dialog, DialogActions, DialogContent, Typography } from "@material-ui/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const AudioContextResolver = ({children}) => {
  const [audioContext, setAudioContext] = useRecoilState(audioContextState);
  const coPilotDisplaySettings = useRecoilValue(coPilotDisplaySettingsSelector);
  const [isResolve, resolve] = useBoolean(audioContext !== null || !coPilotDisplaySettings.alertNotification);
  const {t} = useTranslation();

  const handleDialogClose = useCallback(()=>{
    if (audioContext === null) {
      setAudioContext(new AudioContext())
    }
    resolve()
  }, [audioContext, setAudioContext, resolve])


  if (isResolve) {
    return children
  } else {
    return <Dialog onClose={handleDialogClose} open={!isResolve} disableEscapeKeyDown={true}>
      <DialogContent dividers>
        <Typography>
          {t('A sound will be heard from the browser because the sound notification is ON.')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleDialogClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  }
}
